/**
 * 注：
 * 1. 设计稿中的 brand 是我们变量中的 primary，brand-primary-default 也是 primary
 *    例如设计稿中的brand/secondary/default 是我们的 primarySecondary
 * 2. 设计稿中的变量先在已有 token（包括antd中有，我们文件里没的）中找，
 */
const lightToken = {
    colorPrimary: '#2563EB',
    colorPrimaryWeek: '#EFF6FF',
    colorPrimaryWeeker: '#F8FAFF',
    colorPrimaryDisabled: 'rgba(37, 99, 235, 0.15)',
    colorPrimaryHover: '#1D4ED8',
    colorPrimaryActive: '#1E40AF',
    colorPrimaryBg: '#2563EB',
    colorPrimaryBgHover: '#1D4ED8',
    colorPrimaryBgDisabled: 'rgba(37, 99, 235, 0.15)',
    colorPrimaryAlpha5: '#2563EB0d',
    colorPrimaryAlpha10: '#2563EB1a',
    colorPrimaryAlpha20: '#2563EB33',
    colorPrimaryAlpha40: '#2563EB66',
    colorPrimaryAlpha60: '#2563EB99',
    colorPrimaryAlpha80: '#2563EBcc',
    colorPrimaryBorder: '#E2E8F0',
    colorPrimaryBorderDisabled: '#D1D5DB',
    colorPrimaryBorderHover: '#1E40AF',
    colorPrimaryBorderActive: '#1E3A8A',
    colorPrimarySecondaryActive: '#e37110',
    colorPrimarySecondaryAlpha5: '#f482210d',
    colorPrimarySecondaryAlpha20: '#f4822133',
    colorTextStrong: '#0F172A',
    colorText: '#1E293B',
    colorTextSecondary: '#475569',
    colorTextTertiary: '#94A3B8',
    colorTextPlaceholder: '#94A3B8',
    colorIconHover: '#1D4ED8',
    colorTextBase: '#0F172A',
    colorTextDisabled: '#94A3B8',
    colorErrorText: '#DC2626',
    colorErrorBorder: '#FCA5A5',
    colorErrorBg: '#FEF2F2',
    colorErrorHover: '#F87171',
    colorErrorActive: '#B91C1C',
    colorWarningText: '#D97706',
    colorWarningBgHover: '#FDE68A',
    colorWarningBorder: '#FCD34D',
    colorWarningBg: '#FFFBEB',
    colorWarningActive: '#B45309',
    colorSuccessText: '#16A34A',
    colorSuccessBorder: '#86EFAC',
    colorSuccessBg: '#F0FDF4',
    colorSuccessBgHover: '#BBF7D0',
    colorSuccessActive: '#15803D',
    colorInfoText: '#2563EB',
    colorInfoBorder: '#93C5FD',
    colorInfoBg: '#EFF6FF',
    colorInfoBgHover: '#BFDBFE',
    colorInfoActive: '#1D4ED8',
    colorLink: '#2563EB',
    colorLinkHover: '#1D4ED8',
    colorLinkActive: '#1E40AF',
    colorBorder: '#F1F5F9',
    colorBorderFocus: '#2563EB',
    colorBorderSecondary: '#E2E8F0',
    colorBorderBold: '#CBD5E1',
    colorBorderDisabled: '#F1F5F9',
    colorBgMask: 'rgba(0, 0, 0, 0.5)',
    colorBgContainerDisabled: '#F8FAFC',
    colorBgBase: '#FFFFFF',
    colorItemActiveBg: '#F1F5F9',
    colorHomePageBg: 'linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)',
    colorContentBg: '#F8FAFC',
    colorBgSecondary: 'rgba(100, 116, 139, 0.03)',
    colorContentHoverBg: '#F1F5F9',
    colorSubtleBg: '#FFFFFF',
    colorSubtleBgHover: '#F8FAFC',
    colorReverse: '#0F172A',
    colorListHoverBg: '#F8FAFC',
    colorListSelectedBg: '#EFF6FF',
    colorBoxShadowBase: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
    colorScrollbarBg: 'rgba(148, 163, 184, 0.3)',
    colorScrollbarHoverBg: 'rgba(148, 163, 184, 0.5)',
    colorDropdownActiveBtn: 'rgba(226, 232, 240, 0.6)',
    colorElevationSunkenDefault: '#F8FAFC',
    colorElevationRaisedDefault: '#FFFFFF',
    colorTagsBg: '#F1F5F9',
    colorSurfaceCard: '#FFFFFF',
    colorSurfaceOnCard: '#F8FAFC',
    colorSurfaceOnCardHover: '#F1F5F9',
    colorSurfaceCanvas: '#F8FAFC',
    colorSurfaceHover: '#F1F5F9',
    colorSurfaceBtnPrimary: '#0F172A',
    colorSurfaceBtnPrimaryHover: '#1E293B',
    colorSurfaceBtnDisabled: '#E2E8F0',
    colorReferencePrimary: '#0F172A',
    colorReferenceHelper: '#64748B',
    colorReferenceSecondaryWeak: '#F1F5F9',
    colorBtnText: '#FFFFFF',
    colorSurfaceContrast: '#0F172A',
    colorTextOnContrast: '#F8FAFC'
};

const lightBlue_Token = {
    colorPrimary: '#8EE3F0',
    colorSurfaceOnCard: '#231937',
    colorSurfaceCanvas: '#F8FAFC'
};

const darkToken = {
    colorPrimary: '#60A5FA',
    colorPrimaryWeek: '#1E3A5F',
    colorPrimaryWeeker: '#162D4A',
    colorPrimaryDisabled: '#1A3050',
    colorPrimaryHover: '#93C5FD',
    colorPrimaryActive: '#3B82F6',
    colorPrimaryBg: '#60A5FA',
    colorPrimaryBgHover: '#93C5FD',
    colorPrimaryBgDisabled: 'rgba(96, 165, 250, 0.15)',
    colorPrimaryAlpha5: '#60A5FA0d',
    colorPrimaryAlpha10: '#60A5FA1a',
    colorPrimaryAlpha20: '#60A5FA33',
    colorPrimaryAlpha40: '#60A5FA66',
    colorPrimaryAlpha60: '#60A5FA99',
    colorPrimaryAlpha80: '#60A5FAcc',
    colorPrimaryBorder: 'rgba(255, 255, 255, 0.10)',
    colorPrimaryBorderDisabled: 'rgba(255, 255, 255, 0.06)',
    colorPrimaryBorderHover: '#60A5FA',
    colorPrimaryBorderActive: '#3B82F6',
    colorPrimarySecondaryActive: '#e37110',
    colorPrimarySecondaryAlpha5: '#f482210d',
    colorPrimarySecondaryAlpha20: '#f4822133',
    colorTextStrong: '#F1F5F9',
    colorText: '#E2E8F0',
    colorTextSecondary: '#94A3B8',
    colorTextTertiary: '#64748B',
    colorTextPlaceholder: '#64748B',
    colorIconHover: '#93C5FD',
    colorTextBase: '#F8FAFC',
    colorTextDisabled: '#475569',
    colorErrorText: '#F87171',
    colorErrorBorder: '#991B1B',
    colorErrorBg: 'rgba(239, 68, 68, 0.10)',
    colorErrorHover: '#FCA5A5',
    colorErrorActive: '#DC2626',
    colorWarningText: '#FBBF24',
    colorWarningBorder: '#92400E',
    colorWarningBg: 'rgba(245, 158, 11, 0.10)',
    colorWarningBgHover: '#FDE68A',
    colorWarningActive: '#D97706',
    colorSuccessText: '#4ADE80',
    colorSuccessBorder: '#14532D',
    colorSuccessBg: 'rgba(34, 197, 94, 0.10)',
    colorSuccessBgHover: '#86EFAC',
    colorSuccessActive: '#16A34A',
    colorInfoText: '#60A5FA',
    colorInfoBorder: '#1E3A8A',
    colorInfoBg: 'rgba(59, 130, 246, 0.10)',
    colorInfoBgHover: '#93C5FD',
    colorInfoActive: '#3B82F6',
    colorLink: '#60A5FA',
    colorLinkHover: '#93C5FD',
    colorLinkActive: '#3B82F6',
    colorBorder: 'rgba(255, 255, 255, 0.08)',
    colorBorderFocus: '#60A5FA',
    colorBorderSecondary: 'rgba(255, 255, 255, 0.06)',
    colorBorderBold: 'rgba(255, 255, 255, 0.15)',
    colorBorderDisabled: 'rgba(255, 255, 255, 0.04)',
    colorBgMask: 'rgba(0, 0, 0, 0.6)',
    colorBgContainerDisabled: '#1E293B',
    colorBgBase: '#0F172A',
    colorItemActiveBg: '#1E293B',
    colorHomePageBg: 'linear-gradient(180deg, #0F172A 0%, #020617 100%)',
    colorContentBg: '#020617',
    colorBgSecondary: 'rgba(148, 163, 184, 0.03)',
    colorContentHoverBg: '#1E293B',
    colorSubtleBg: '#0F172A',
    colorSubtleBgHover: '#1E293B',
    colorReverse: '#F8FAFC',
    colorListHoverBg: '#1E293B',
    colorListSelectedBg: '#1E3A5F',
    colorBoxShadowBase: '0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 6px -1px rgba(0, 0, 0, 0.15), 0 2px 4px 0 rgba(0, 0, 0, 0.1)',
    colorScrollbarBg: 'rgba(148, 163, 184, 0.2)',
    colorScrollbarHoverBg: 'rgba(148, 163, 184, 0.35)',
    colorDropdownActiveBtn: 'rgba(148, 163, 184, 0.15)',
    colorElevationSunkenDefault: '#020617',
    colorElevationRaisedDefault: '#1E293B',
    colorTagsBg: '#1E293B',
    colorSurfaceCard: '#0F172A',
    colorSurfaceOnCard: '#020617',
    colorSurfaceOnCardHover: '#1E293B',
    colorSurfaceCanvas: '#020617',
    colorSurfaceHover: '#1E293B',
    colorSurfaceBtnPrimary: '#E2E8F0',
    colorSurfaceBtnPrimaryHover: '#F1F5F9',
    colorSurfaceBtnDisabled: '#1E293B',
    colorReferencePrimary: '#E2E8F0',
    colorReferenceHelper: '#94A3B8',
    colorReferenceSecondaryWeak: 'rgba(100, 116, 139, 0.20)',
    colorBtnText: '#0F172A',
    colorSurfaceContrast: '#1E293B',
    colorTextOnContrast: '#E2E8F0'
};

module.exports = {
    lightToken,
    darkToken,
    lightBlue_Token
};
